import React from 'react'
import { useDispatch } from 'react-redux'
import { Image, ListGroup } from 'react-bootstrap'
import FontAwesomeIcon from '@severed-links/common.font-awesome-icon'
import Player from '../Player/Player'
import moment from 'moment-timezone'
import { toggleTicketModal, setActiveTicket, loadActiveTicket } from '@severed-links/common.redherrings-reducers/help'
import * as s from './HelpCenter.scss'
import { img } from '@severed-links/common.redherrings-constants'
import LastTicketUpdate from './LastTicketUpdate'
import { camelCase } from 'lodash'

const TicketListItem = ({ t = {} }) => {

    const dispatch = useDispatch()

    const openTicket = ticket => {
        dispatch(setActiveTicket(ticket))
        dispatch(toggleTicketModal(true))
        dispatch(loadActiveTicket(ticket._id))
    }

    const createImageUrl = app => {
        const appRoot = `${(app || '').replace('Player', '')}HeaderMobile`
        return `${img.CloudinaryBaseUrl}${(img[appRoot] ? img[appRoot] : img.RedHerringsBlockLogo)}`
    }

    const getTicketTypeIcon = ticketType => {
        if (ticketType === 'Bug') return 'bug'
        if (ticketType === 'Feature Request') return 'star'
        if (ticketType === 'Comment') return 'comment'
        return 'question'
    }

    const getTicketStatus = ticket => {
        if (ticket.isDeletedTicket) return 'Deleted'
        if (ticket.isCompletedTicket) return 'Completed'
        return ticket.createDate === ticket.updateDate ? 'Created' : 'Updated'
    }

    if (!t) return null
    const _imageUrl = createImageUrl(t.app)
    const _ticketTypeClass = t.ticketType ? s[camelCase(t.ticketType.replace(/\s+/gi, ''))] : ''
    const _commentCount = Array.isArray(t.comments) ? t.comments.length : (t.commentCount || t.numComments || 0)
    const _ticketStatus = getTicketStatus(t)
    const _description = t.description || t.subject || 'No description provided.'
    const _player = t.player || {}

    return (
        <ListGroup.Item className={s.ticketListItem}
            onClick={() => openTicket(t)} action>
            {t.app && _imageUrl ?
            <div className={s.appIcon}>
                <Image src={_imageUrl} />
            </div>
            : null}

            <div className={s.ticketMedia}>
                <div className={s.avatar}>
                    <Player onlyAvatar isLarge playerId={_player._id} fullName={_player.fullName} avatarUrl={_player.avatarUrl} />
                </div>
                <div className={s.ticketTypeIcon + (_ticketTypeClass ? ` ${_ticketTypeClass}` : '')}>
                    <FontAwesomeIcon name={getTicketTypeIcon(t.ticketType)} />
                </div>
            </div>

            <div className={s.ticketBody}>
                <div className={s.ticketHeader}>
                    <div>
                        <div className={s.name}>
                            <Player onlyName playerId={_player._id} fullName={_player.fullName} avatarUrl={_player.avatarUrl} />
                        </div>
                        <div className={s.subject}>{`Ticket #${t.ticketNumber || ''}${t.subject ? `: ${t.subject}` : ''}`}</div>
                    </div>
                </div>
                <div className={s.description}>{_description}</div>
                <div className={s.ticketMeta}>
                    <span className={`${s.statusChip} ${s[camelCase(_ticketStatus)]}`}>{_ticketStatus}</span>
                    {t.updateDate ? <span className={s.date}><LastTicketUpdate dateUpdated={moment(t.updateDate).toISOString()} /></span> : null}
                    {_commentCount > 0 ?
                    <span className={s.commentCount}>
                        <FontAwesomeIcon name='comment' />
                        <span>{_commentCount}</span>
                    </span>
                    : null}
                </div>
            </div>

            <div className={s.chevron}>
                <FontAwesomeIcon name='chevron-right' />
            </div>
        </ListGroup.Item>
    )
}

export default TicketListItem
